











































































import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import Modal from '@/modules/common/dialog/components/shared/Modal.vue'
import Toggle from '@/modules/shared/components/shared/kit/Toggle.vue'
import Checkbox from '@/modules/shared/components/shared/kit/Checkbox.vue'
import Radio from '@/modules/shared/components/shared/kit/Radio.vue'
import { mixins } from 'vue-class-component'
import DialogMixin from '@/modules/common/dialog/mixins/DialogMixin'
import {
  CampaignItemPaymentCollectionModelInAdmin,
  CampaignItemPaymentCollectionWithModel
} from '@/modules/campaign-item-payment/models/campaign-item-payment-collection.model'
import CampaignItemPaymentStatusView
  from '@/modules/campaign-item-payment/components/shared/CampaignItemPaymentStatusView.vue'
import DateTooltipped from '@/modules/shared/components/shared/utils/DateTooltipped.vue'
import AdminUserInfoButton from '@/modules/user/components/admin/AdminUserInfoButton.vue'
import CampaignItemPaymentItemTypeView
  from '@/modules/campaign-item-payment/components/shared/CampaignItemPaymentItemTypeView.vue'
import CampaignItemPaymentTypeView
  from '@/modules/campaign-item-payment/components/shared/CampaignItemPaymentTypeView.vue'
import PriceView from '@/modules/shared/components/shared/PriceView.vue'


@Component({
  components: {
    PriceView,
    CampaignItemPaymentTypeView,
    CampaignItemPaymentItemTypeView,
    AdminUserInfoButton,
    CampaignItemPaymentStatusView,
    BaseButton,
    Modal,
    Toggle,
    Checkbox,
    Radio,
    DateTooltipped
  }
})
export default class AdminCampaignItemPaymentItemInfoDialog extends mixins<DialogMixin>(DialogMixin) {

  @Prop() payment: CampaignItemPaymentCollectionModelInAdmin
  @Prop() withData: CampaignItemPaymentCollectionWithModel
  @Prop({ default: 'اطلاعات آیتم تسویه' }) label: string

  private dialogModel: boolean = false

  private labelName = {
    id: 'شناسه',
    amount: 'مقدار',
    item_type: 'نوع آیتم',
    item_id: 'شماره آیتم',
    payment_type: 'نوع تسویه',
    created_at: 'تاریخ ایجاد',
    status: 'وضعیت',
    deposit_id: 'شماره واریزی',
    reservation_id: 'شماره رزرو',
    description: 'توضیحات',
    author: 'نویسنده'
  }

  show() {
    this.dialogModel = true
  }
}
